<!-- 兑换记录 -->
<template>
  <div class="content">
      <div class="bodycontent">
          <div class="top">
            <el-row :gutter="20" style="width:100%">
              <el-col :span="6">
                <router-link to="/activeCenter/adActive">
                  <el-button type="primary" icon="el-icon-plus">
                    新增活动 
                  </el-button>
                </router-link>
              </el-col>
            </el-row>
          </div>
          <div class="cont">
            <el-table
              :data="tableData"
              style="width: 100%">
              <el-table-column
                label="活动分享图"
                width="180">
                  <template slot-scope="scope">
                  <img :src="scope.row.cover_url" alt="" style="width:50px; height: auto">
                </template>
              </el-table-column>
              <el-table-column
                prop="name"
                label="活动名称"
                width="180">
              </el-table-column>
              <el-table-column
                label="时间">
                <template slot-scope="scope">
                  {{ scope.row.start_time}} - {{ scope.row.end_time}}
                </template>
              </el-table-column>
              <el-table-column
                prop="num"
                label="报名数">
                </el-table-column>
              <el-table-column
                label="操作">
                <template slot-scope="scope">
                  <el-button size="mini" @click="handle(1,scope.row.id)">编辑</el-button>
                  <el-button size="mini" @click="handle(0,scope.row.id)">删除</el-button>
                </template>
                  
              </el-table-column>
            </el-table>
            
          </div>
      </div>
  </div>
</template>

<script>
import { activeList, deleteactive } from "@/api/active";
import { mapGetters } from "vuex";
export default {
  inject: ["reload"],
  computed: {
    ...mapGetters(["app_id", "token"])
  },
  data () {
    return {
      data: "",
      screenInput: "",
      
      tableData: [],
    };
  },

  components: {},
  mounted(){
    this.getList();
  },
  methods: {
    // 筛选
    screen(){
      console.log("screenInput", this.screenInput);
      let data = {
        token: this.token,
        app_id: this.app_id,
        type: this.screenInput,
        store_id: 0, //
      }
      activeList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      })
    },
    getList(){
      let data = {
        token: this.token,
        app_id: this.app_id,
        store_id: 0, //
      }
      activeList(data).then(res => {
        console.log("订单列表", res);
        this.tableData = res.data.result;
      })
    },
    // 操作 type 1 编辑 0 删除 index =>对应商品id
    handle(type, index) {
      if(type == 1){
        this.$router.push({ name: "adActive", query: { idE: index } });
      }else{
        let data = {
          token: this.token,
          app_id: this.app_id,
          store_id: 0, //
          id: index
        }
        this.$confirm('是否删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteactive(data).then( res => {
            console.log("shanchu ", res)
            if(res.code == 200){
              this.$message.success(res.msg);
              this.reload();
            }else{
              this.$message("删除失败");
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        });
        
      }
      
    },
  }
}
</script>
<style lang= 'scss' scoped>
@import "./public/style/_interfacePublic";
.flex {
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.padding {
  padding: 20px;
}
.content{
  width: 100%;
  .bodycontent {
    height: 100%;
    overflow: auto;
    .top {
      height: 80px;
      padding: 20px 0;
    }
    .cont{
      height: calc(100% - 80px);
      .table{
        border: 1px solid #eeeeee;
        .title{
          height: 60px;
          line-height: 60px;
          background: #f5f7fa;
        }
        .list{
          padding: 20px 0 20px;
          .box{
            border: 1px solid #f1f1f1;
            .bianhao{
              height: 40px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              background: #f5f7fa;
            }

          }
        }
      }
    }
  }
}
</style>